import React, { useState } from "react";
import { useQueryParam, StringParam } from "use-query-params";

export const SearchQueryContext = React.createContext(null);

export interface searchQueryType {
  searchQuery: string;
  setSearchQuery: any;
}

export const SearchQueryProvider: React.FC<{}> = (
  {children}
) => {

  const [searchQuery, setSearchQuery] = useQueryParam('q', StringParam);

  const value = {
    searchQuery,
    setSearchQuery
  }

  return (
    <SearchQueryContext.Provider value={value}>
      {children}
    </SearchQueryContext.Provider>
  )
}
